export default __webpack_public_path__ + "static/media/ComputadorExchangeMobile.92820c6b.png";